import React from 'react';
import { useTranslation } from '@shared/core';
import { SimpleGrabHandle } from '@website-editor/components/SimpleGrabHandle';
import { Clock } from '@withjoy/joykit/icons';
import { AdminSidebarComponentProps } from '../../JsonComponent.types';
import { useEventInfo } from '@shared/utils/eventInfo';
import { useCountdown } from '@shared/hooks/useCountdown';

export const EventCountdownGrabber = (props: AdminSidebarComponentProps) => {
  const { tq } = useTranslation('eventCountdownCustomComponent');
  const { eventInfo } = useEventInfo();
  const date = eventInfo?.finalizedDate;
  const { formattedDuration } = useCountdown(date?.milliseconds, props.componentData.containerContent.content?.countdownFormat);
  const subTitle = date ? formattedDuration : '';

  return (
    <SimpleGrabHandle
      title={tq`Event Countdown`}
      subTitle={subTitle}
      icon={<Clock size="lg" />}
      {...props}
    />
  );
};
